'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _appkitReact = require('appkit-react');

var _KeyboardHoverOnlyDiv = require('../utils/KeyboardHoverOnlyDiv');

var _KeyboardHoverOnlyDiv2 = _interopRequireDefault(_KeyboardHoverOnlyDiv);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var babelPluginFlowReactPropTypes_proptype_Node = require('react').babelPluginFlowReactPropTypes_proptype_Node || require('prop-types').any;

var babelPluginFlowReactPropTypes_proptype_CommonType = require('appkit-react-utils/commonType').babelPluginFlowReactPropTypes_proptype_CommonType || require('prop-types').any;

var STATUS = ['dark', 'info', 'success', 'warning', 'error'];

var Alert = function (_Component) {
  _inherits(Alert, _Component);

  function Alert(props) {
    _classCallCheck(this, Alert);

    var _this = _possibleConstructorReturn(this, (Alert.__proto__ || Object.getPrototypeOf(Alert)).call(this, props));

    _this.onClose = function () {
      var _this$props = _this.props,
          onClose = _this$props.onClose,
          willUnmount = _this$props.willUnmount;

      _this.stopTimer();
      _this.setState({
        visiable: false
      });
      _this.forceUpdate(function () {
        willUnmount && willUnmount();
      });
      onClose && onClose();
    };

    _this.timer = 0;
    _this.state = {
      visiable: true
    };
    return _this;
  }

  _createClass(Alert, [{
    key: 'startTimer',


    //----------TIMER LOGIC STARTS  HERE
    value: function startTimer() {
      var _this2 = this;

      if (this.props.closeable !== true && this.props.duration) {
        this.timer = setTimeout(function () {
          _this2.onClose();
        }, this.props.duration);
      }
    }
  }, {
    key: 'stopTimer',
    value: function stopTimer() {
      if (this.timer) {
        clearTimeout(this.timer);
      }
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.startTimer();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      this.stopTimer();
      this.startTimer();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.stopTimer();
    }
  }, {
    key: 'renderBadge',

    //----------TIMER LOGIC ENDS  HERE
    value: function renderBadge() {
      var _props = this.props,
          showDefaultIcon = _props.showDefaultIcon,
          icon = _props.icon,
          status = _props.status;


      if (icon) {
        return _react2.default.createElement(
          'div',
          { className: 'a-alert-icon-wrapper' },
          icon
        );
      } else if (showDefaultIcon) {
        if (status === "dark") {
          return _react2.default.createElement(
            'div',
            { className: 'a-alert-icon-wrapper' },
            _react2.default.createElement('span', { className: 'a-alert-icon appkiticon icon-help-question-fill' })
          );
        } else if (status === "info") {
          return _react2.default.createElement(
            'div',
            { className: 'a-alert-icon-wrapper' },
            _react2.default.createElement('span', { className: 'a-alert-icon appkiticon icon-information-fill' })
          );
        } else if (status === "success") {
          return _react2.default.createElement(
            'div',
            { className: 'a-alert-icon-wrapper' },
            _react2.default.createElement('span', { className: 'a-alert-icon appkiticon icon-confirmed-fill' })
          );
        } else if (status === "warning") {
          return _react2.default.createElement(
            'div',
            { className: 'a-alert-icon-wrapper' },
            _react2.default.createElement('span', { className: 'a-alert-icon appkiticon icon-alert-fill' })
          );
        } else if (status === "error") {
          return _react2.default.createElement(
            'div',
            { className: 'a-alert-icon-wrapper' },
            _react2.default.createElement('span', { className: 'a-alert-icon appkiticon  icon-alert-fill a-icon-error' })
          );
        } else {
          //unsupport
          return _react2.default.createElement('div', { className: 'a-alert-icon-wrapper' });
        }
      } else {
        return _react2.default.createElement(
          _appkitReact.Badge,
          { type: status },
          status && status.toUpperCase()
        );
      }
    }
  }, {
    key: 'onEnterKeydown',
    value: function onEnterKeydown(e) {
      if (e.key === "Enter") {
        this.onClose();
      }
    }
  }, {
    key: 'renderCountDownTimerOrCloseButton',
    value: function renderCountDownTimerOrCloseButton() {
      if (this.props.closeable) {
        return _react2.default.createElement(
          _KeyboardHoverOnlyDiv2.default,
          { className: 'a-alert-close', onClick: this.onClose, onKeyDown: this.onEnterKeydown.bind(this) },
          _react2.default.createElement('span', { className: 'appkiticon icon-close-fill' })
        );
      } else if (this.props.duration > 0) {
        var animationStyle = {
          "animationDuration": this.props.duration / 1000 + "s"
        };
        return _react2.default.createElement(
          'div',
          { className: 'a-countdown-wrapper' },
          _react2.default.createElement(
            'svg',
            { height: '16', width: '16' },
            _react2.default.createElement('circle', { style: animationStyle, className: 'a-circle a-countdown animated', cx: '8', cy: '8', r: '4' })
          )
        );
      } else {
        return undefined;
      }
    }
  }, {
    key: 'renderFooter',
    value: function renderFooter() {
      return this.props.children && _react2.default.createElement(
        'div',
        { className: 'alert-footer' },
        this.props.children
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _ClassNames;

      var _props2 = this.props,
          status = _props2.status,
          icon = _props2.icon,
          closeable = _props2.closeable,
          style = _props2.style,
          className = _props2.className,
          message = _props2.message,
          children = _props2.children,
          oneLineDisplay = _props2.oneLineDisplay,
          willUnmount = _props2.willUnmount,
          showDefaultIcon = _props2.showDefaultIcon,
          otherProps = _objectWithoutProperties(_props2, ['status', 'icon', 'closeable', 'style', 'className', 'message', 'children', 'oneLineDisplay', 'willUnmount', 'showDefaultIcon']);

      var mode = oneLineDisplay ? "one-line" : "mulitiple-line";

      var alertClassName = (0, _classnames2.default)('a-alert', mode, (_ClassNames = {}, _defineProperty(_ClassNames, 'a-alert-' + status, status), _defineProperty(_ClassNames, 'a-alert-has-icon', icon || showDefaultIcon), _ClassNames));

      var wrapperClassName = (0, _classnames2.default)("a-alert-wrapper", mode, className, {
        'hidden': !this.state.visiable
      });

      return _react2.default.createElement(
        'div',
        { className: wrapperClassName },
        _react2.default.createElement(
          'div',
          Object.assign({ className: alertClassName, style: style }, otherProps),
          this.renderBadge(),
          _react2.default.createElement(
            'div',
            { className: 'a-alert-text-content' },
            message
          ),
          this.renderCountDownTimerOrCloseButton()
        ),
        this.renderFooter()
      );
    }
  }]);

  return Alert;
}(_react.Component);

Alert.defaultProps = {
  duration: 0,
  status: 'success',
  oneLineDisplay: true,
  showDefaultIcon: false
};


Alert.propTypes = {
  status: _propTypes2.default.oneOf(STATUS),
  icon: _propTypes2.default.any,
  closeable: _propTypes2.default.bool,
  oneLineDisplay: _propTypes2.default.bool,
  message: _propTypes2.default.any,
  duration: _propTypes2.default.number,
  onClose: _propTypes2.default.func,
  showDefaultIcon: _propTypes2.default.bool,
  style: _propTypes2.default.object,
  className: _propTypes2.default.string
};

Alert.displayName = 'Alert';
Alert.supportedStatus = STATUS;

exports.default = Alert;